/**
 * Text Accordion Pattern
 * Toggle accordion items open/closed on header click.
 */
$(document).ready(function () {
  // Set concrete max-height on initially open items so closing animates correctly
  $('.pattern-text-accordion .accordion-item.active .accordion-content').each(function () {
    $(this).css('max-height', this.scrollHeight + 'px');
  });

  $(document).on('click', '.pattern-text-accordion .accordion-header', function () {
    const $header = $(this);
    const $item = $header.closest('.accordion-item');
    const $content = $item.find('.accordion-content');
    const isActive = $item.hasClass('active');

    // Close all items in this accordions-group
    const $group = $item.closest('.accordions-group');
    $group.find('.accordion-item.active').each(function () {
      $(this).removeClass('active');
      $(this).find('.accordion-header').attr('aria-expanded', 'false');
      $(this).find('.accordion-content').css('max-height', '0');
    });

    // Open clicked item if it was closed
    if (!isActive) {
      $item.addClass('active');
      $header.attr('aria-expanded', 'true');
      $content.css('max-height', $content[0].scrollHeight + 'px');
    }
  });
});
